module.exports = __webpack_public_path__ + "fonts/icon_set_1.2cf43844.ttf";